import type { ErrorCopy } from '@shared/errors/catalog';

import { contentAndAssetsErrors } from '../_shared/errors';

/**
 * The codes this surface meets — both services, because the record lives in one
 * and the bytes in the other.
 *
 * Two matter most here. `CONTENT_LAST_ASSET_OF_PUBLISHED_ITEM` is **the one
 * guard on removal**, and its copy names the way out rather than only the
 * refusal — which is also what the dialog says before the request is ever made.
 * `ASSETS_PREVIEW_LIMIT_REACHED` is the free-marking bound, and its copy names
 * which of the two facts the operator can change.
 */
export const errors: Readonly<Record<string, ErrorCopy>> = contentAndAssetsErrors;
